import { collection, doc, getDocs, query, where, updateDoc, serverTimestamp } from 'firebase/firestore';
import {
  notifyOrganizationInviteAccepted,
  notifyOrganizationInviteCreated,
  notifyOrganizationInviteDeclined,
} from './notifications';
import { PLATFORM_COLLECTIONS } from './platformSchema';
import { planInstructorAuthBackfill } from './instructorAuthBackfill';

export async function onOrganizationInviteCreated(db, invite = {}) {
  try {
    await notifyOrganizationInviteCreated(db, invite);
  } catch (error) {
    console.error('Failed to notify organization invite creation:', error);
  }
  return invite;
}

export async function onOrganizationInviteAccepted(db, invite = {}, membership = {}) {
  try {
    await notifyOrganizationInviteAccepted(db, invite, membership);
  } catch (error) {
    console.error('Failed to notify organization invite acceptance:', error);
  }
  return { invite, membership };
}

export async function onOrganizationInviteDeclined(db, invite = {}) {
  try {
    await notifyOrganizationInviteDeclined(db, invite);
  } catch (error) {
    console.error('Failed to notify organization invite decline:', error);
  }
  return invite;
}

// Pass 55 Stage D (item G) — WIRED Auth backfill. When a membership is activated with a linked
// authUserId, reveal its already-assigned bookings by setting ONLY booking.instructorAuthUserId
// (never reassignment, never createdAt rewrite, never a notification). Reuses the Pass-51 planner.
export async function onOrganizationMembershipActivated(db, membership = {}, invite = {}) {
  const backfill = { attempted: 0, updated: 0 };
  try {
    if (membership.authUserId && membership.userId && membership.organizationId) {
      const snap = await getDocs(query(
        collection(db, PLATFORM_COLLECTIONS.BOOKINGS),
        where('organizationId', '==', membership.organizationId),
        where('instructorId', '==', membership.userId),
      ));
      const bookings = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const { updates } = planInstructorAuthBackfill(membership, bookings);
      backfill.attempted = updates.length;
      for (const u of updates) {
        await updateDoc(doc(db, PLATFORM_COLLECTIONS.BOOKINGS, u.bookingId), { ...u.set, updatedAt: serverTimestamp() });
        backfill.updated += 1;
      }
    }
  } catch (error) {
    console.error('Auth backfill on membership activation failed:', error);
  }
  return { membership, invite, backfill };
}
